import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import DayTimeline from './dayTimeline.js'
import TimelineTitle from './timelineTitle.js'
import WeekButtons from './weekButtons.js'
import InfoCard from './infoCard.js'
import DayTimeCalendar from './dayTimeCalendar.js';
import TimelineSelect from './timelineSelect.js';
import CloseIcon from '@material-ui/icons/Close';

import Slide from '@material-ui/core/Slide';
import { ToggleActions } from '../../constants/constants.js';
import { dayChange, toggleSwitch } from '../../actions/index.js';


class TimelineCard extends React.Component {

    handleCloseChange = () => {
        this.props.toggleSwitch(ToggleActions.TIMELINE, false);
        this.props.dayChange({
            first: this.props.projectData.days[0].id, 
            last: this.props.projectData.days[this.props.projectData.days.length - 1].id
        })
    }

    render() {
        return(
            <div>
                <Slide in={ this.props.timeline && !this.props.popUpMenu.show} direction='left'>
                    <div className={this.props.metrics || this.props.graph ? "timeline-card-layout timeline-left card-color" : "timeline-card-layout card-color"}>
                        <CloseIcon className='float-right cursor-pointer m-2' onClick={this.handleCloseChange}/>
                        <div className="timeline-card-section">
                            {/* <TimelineTitle/> */}
                            <TimelineSelect/>
                            {/* <InfoCard/> */}
                            {/* <WeekButtons/> */}
                            <DayTimeCalendar/>
                            {/* <DayTimeline/> */}
                        </div>
                    </div>
                </Slide>
            </div>
        );
    } 
}

function mapStateToProps( state ){
    return {
        day: state.day,
        timeline: state.switches.timeline,
        metrics : state.switches.metrics,
        popUpMenu: state.popUpMenu,
        projectData: state.projectData
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        toggleSwitch: toggleSwitch,
        dayChange: dayChange
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(TimelineCard);